// hooks/useDataFetching.js
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { apiCall } from '../services/apiService';

const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const fetchData = async () => {
      try {
        const response = await apiCall('api/data');

        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await response.json();
        setRows(data);
        setFilteredRows(data);
      } catch (err) {
        setError('Error fetching data, please refresh the page');
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ rows, filteredRows, setFilteredRows, loading, error }}>
      {children}
    </DataContext.Provider>
  );
};

export const useDataFetching = () => {
  const ctx = useContext(DataContext);
  if (!ctx) {
    throw new Error('useDataFetching must be used within a DataProvider');
  }
  return ctx;
};